import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { firestore } from "../../config/ConfigFirebase";

// Configuración del módulo de Convenios (Extensión). Vive en config/agreements
// y sólo guarda las políticas del tablero de convenios.
//
// El catálogo documental de las entidades, los sectores, el bucket y el registro
// público NO viven aquí: se mudaron a config/entities (ver EntityConfigService),
// porque una entidad no le pertenece a Convenios — Contratos la va a consumir
// igual. getEntityConfig() sigue leyendo config/agreements como respaldo
// mientras un entorno no haya guardado su configuración en el sitio nuevo.

export const DEFAULT_AGREEMENT_CONFIG = {
  // Ventana de "próximo a vencer" del tablero de convenios. Vive aquí y no en el
  // código porque es una política de la Dirección, no una constante técnica.
  soonDays: 30,
  // A partir de qué porcentaje comprometido el tablero avisa. El 100% se marca
  // siempre como error, pase lo que pase con este número.
  budgetWarningPercentage: 85,
};

// Claves que esta pantalla posee. Explícitas para que un guardado nunca pise
// campos ajenos, igual que GLOBAL_CONFIG_KEYS en AppConfigService.
export const AGREEMENT_CONFIG_KEYS = Object.keys(DEFAULT_AGREEMENT_CONFIG);

const pick = (obj, keys) => Object.fromEntries(keys.filter((k) => k in obj).map((k) => [k, obj[k]]));

// Lee config/agreements sobre los valores por defecto, de modo que quien lo
// consuma reciba siempre un objeto completo. Devuelve los defaults ante un
// error o si el documento no existe.
export const getAgreementConfig = async () => {
  try {
    const snap = await getDoc(doc(firestore, "config", "agreements"));
    const data = snap.exists() ? snap.data() : {};
    return { ...DEFAULT_AGREEMENT_CONFIG, ...pick(data, AGREEMENT_CONFIG_KEYS) };
  } catch (e) {
    console.error("getAgreementConfig error:", e);
    return { ...DEFAULT_AGREEMENT_CONFIG };
  }
};

// Escritura con merge, acotada a las claves propias.
export const saveAgreementConfig = async (patch) => {
  try {
    await setDoc(
      doc(firestore, "config", "agreements"),
      { ...pick(patch, AGREEMENT_CONFIG_KEYS), updatedAt: serverTimestamp() },
      { merge: true }
    );
    return true;
  } catch (e) {
    console.error("saveAgreementConfig error:", e);
    return false;
  }
};
